import axios from 'axios';
import { destructureAxiosReq, trimValues } from 'shared/lib/utils';

/**
 * Send lead email.
 *
 * @param {Object} opts The options.
 * @param {Object} opts.firstName The user's first name.
 * @param {Object} opts.lastName The user's last name.
 * @param {Object} opts.email The user's email.
 * @param {Object} opts.phoneNumber The user's phone number.
 * @param {Object} opts.jobTitle The user's job title.
 * @param {Object} opts.companyName The user's company name.
 * @param {Object} opts.companySize The user's company size.
 * @param {Object} opts.country The user's country.
 * @param {Object} [opts.comment] The user's comment.
 */
export function sendLeadEmail(opts) {
  const payload = trimValues({
    first_name: opts.firstName,
    last_name: opts.lastName,
    email: opts.email,
    phone_number: opts.phoneNumber,
    job_title: opts.jobTitle,
    company_name: opts.companyName,
    company_size: opts.companySize,
    country: opts.country,
    comment: opts.comment,
  });

  return destructureAxiosReq(
    axios.post(
      `${process.env.REACT_APP_SURE_API_BASE_URL}/api/user/v2/lead-email`,
      payload
    )
  );
}
